var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('product-form',{attrs:{"product":_vm.product,"loading":_vm.loading},on:{"submit":_vm.updateProduct}})}
var staticRenderFns = []

export { render, staticRenderFns }